import * as React from 'react'

import Svg, { ClipPath, Defs, G, Mask, Path } from 'react-native-svg'

import { IconProps } from '..'

const DigitalGoldCategories = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <G clipPath="url(#b)">
        <Mask
          id="c"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={1}
          y={1}
          width={25}
          height={26}
        >
          <Path d="M1 1h25v26H1V1Z" fill="#fff" />
        </Mask>
        <G mask="url(#c)">
          <Path
            d="m6.327 24.516 15.543-1.07c2.217-2.257 3.593-5.405 3.593-8.887 0-6.872-5.356-12.442-11.963-12.442-6.607 0-11.963 5.57-11.963 12.442 0 4.072 1.882 7.688 4.79 9.957Z"
            fill="#54A0FF"
          />
          <Path
            d="m24.015 7.278-1.016-.284-8.417-2.345c-1.042-.29-2.113.353-2.392 1.436L7.41 24.64h13.102c.48-.362.935-.76 1.359-1.192l3.153-12.238.372-1.444c.279-1.083-.34-2.197-1.381-2.487Z"
            fill="#EAB540"
          />
          <Path
            d="m23.825 8.013-.18-.05-9.252-2.579c-.652-.18-1.321.22-1.495.898L8.168 24.64h12.345c.124-.093.246-.189.367-.287l3.72-14.44.088-.344c.175-.677-.211-1.373-.863-1.555Z"
            fill="#FECA57"
          />
          <Path
            d="m11.2 24.64 4.527-17.57c.175-.676.844-1.078 1.495-.897l-2.83-.788c-.65-.182-1.32.22-1.495.897L8.167 24.64h3.034Z"
            fill="#FFB332"
          />
          <Path
            d="M16.455 17c-2.214-.617-3.528-2.984-2.935-5.287s2.87-3.67 5.083-3.052c2.214.617 3.528 2.984 2.935 5.286-.593 2.303-2.869 3.67-5.083 3.053Z"
            fill="#FFECBC"
          />
          <Path
            d="M16.644 16.264c-1.82-.508-2.904-2.46-2.416-4.354.487-1.893 2.365-3.02 4.186-2.513 1.82.507 2.904 2.46 2.417 4.353-.488 1.893-2.366 3.021-4.187 2.514Z"
            fill="#EAB540"
          />
          <Path
            d="M19.887 13.487a1.565 1.565 0 0 0-.407-1.5 1.017 1.017 0 0 1-.274-.493 1.499 1.499 0 0 0-1.045-1.116 1.43 1.43 0 0 0-1.442.423.962.962 0 0 1-.475.285c-.504.127-.93.53-1.073 1.087-.144.558.03 1.127.407 1.5.135.133.23.305.274.493.122.525.51.967 1.045 1.117a1.43 1.43 0 0 0 1.442-.424.961.961 0 0 1 .475-.285c.505-.127.93-.53 1.073-1.087Z"
            fill="#FFC839"
          />
          <Path
            d="M17.276 13.811c-.52-.145-.83-.703-.69-1.244.14-.54.676-.863 1.196-.718.52.145.83.703.69 1.244-.139.541-.675.863-1.196.718Z"
            fill="#FFECBC"
          />
          <Path
            d="M20.513 24.64A11.601 11.601 0 0 1 13.5 27a11.61 11.61 0 0 1-7.173-2.484L2.5 9.662l-.896-3.476c-.279-1.083.34-2.198 1.382-2.488l9.432-2.628c.932-.26 1.887.228 2.279 1.109.045.104.084.213.113.327l5.703 22.133Z"
            fill="#EAB540"
          />
          <Path
            d="M19.87 25.09A11.57 11.57 0 0 1 13.5 27c-2.29 0-4.429-.669-6.246-1.83L2.988 8.616l-.676-2.626c-.175-.677.212-1.373.863-1.555l9.432-2.629c.43-.12.869.015 1.167.316.153.154.27.352.329.582l5.768 22.388Z"
            fill="#FECA57"
          />
          <Path
            d="M10.668 26.65a11.63 11.63 0 0 1-3.414-1.48L2.988 8.616l-.676-2.626c-.175-.677.212-1.373.863-1.555l2.83-.788c-.651.181-1.038.877-.863 1.555l.093.363 5.433 21.085Z"
            fill="#FFC839"
          />
          <Path
            d="M10.545 13.42c-2.214.617-4.49-.749-5.083-3.052-.593-2.302.72-4.67 2.935-5.286 2.214-.617 4.49.75 5.083 3.052.593 2.303-.72 4.67-2.935 5.287Z"
            fill="#FFC839"
          />
          <Path
            d="M10.356 12.685c-1.82.507-3.699-.62-4.187-2.514-.487-1.893.597-3.846 2.417-4.353 1.82-.508 3.699.62 4.187 2.513.487 1.893-.597 3.846-2.417 4.354Z"
            fill="#EAB540"
          />
          <Path
            d="M8.586 5.818c-1.82.507-2.904 2.46-2.417 4.353.488 1.893 2.366 3.021 4.187 2.514a.487.487 0 0 1-.598-.36.51.51 0 0 1 .345-.621L8.839 6.799a.487.487 0 0 1-.598-.36.51.51 0 0 1 .345-.621Z"
            fill="#EAB540"
          />
          <Path
            d="M11.83 8.594a1.494 1.494 0 0 0-1.075-1.087.961.961 0 0 1-.474-.285A1.43 1.43 0 0 0 8.839 6.8c-.536.149-.923.591-1.045 1.116-.044.189-.139.36-.274.494a1.565 1.565 0 0 0-.407 1.5c.143.557.568.96 1.073 1.086a.96.96 0 0 1 .475.285 1.43 1.43 0 0 0 1.442.424c.536-.15.923-.592 1.045-1.117.043-.188.139-.36.274-.493.376-.373.55-.942.407-1.5Z"
            fill="#FECA57"
          />
          <Path
            d="M9.724 10.232c-.52.145-1.057-.177-1.196-.718-.14-.54.17-1.099.69-1.244.52-.145 1.057.177 1.196.718.14.541-.17 1.1-.69 1.244Z"
            fill="#FFECBC"
          />
          <Path
            d="M9.47 9.251a1.043 1.043 0 0 1 .254-.98.933.933 0 0 0-.506 0c-.52.144-.83.702-.69 1.243.139.541.676.863 1.196.718a.963.963 0 0 0 .437-.264.996.996 0 0 1-.69-.717Z"
            fill="#FFECBC"
          />
          <Path
            d="M13.768 25.928a.73.73 0 0 1-.897-.538c-.105-.406.128-.824.518-.933a.73.73 0 0 1 .897.538c.104.406-.128.825-.518.933Z"
            fill="#FFC839"
          />
          <Path
            d="m14.04 17.178-4.716 1.314a.73.73 0 0 1-.897-.538.765.765 0 0 1 .518-.933l4.717-1.315a.73.73 0 0 1 .897.539.765.765 0 0 1-.518.933Z"
            fill="#FFECBC"
          />
          <Path
            d="M10.314 17.428a.765.765 0 0 1 .518-.933l-1.887.526a.765.765 0 0 0-.518.933.73.73 0 0 0 .897.538l1.887-.526a.73.73 0 0 1-.897-.538Z"
            fill="#fff"
          />
          <Path
            d="m15.742 19.858-6.603 1.84a.73.73 0 0 1-.897-.538.765.765 0 0 1 .518-.933l6.603-1.84a.73.73 0 0 1 .897.538.765.765 0 0 1-.518.933Z"
            fill="#FFECBC"
          />
          <Path
            d="M10.129 20.634a.765.765 0 0 1 .518-.933l-1.887.526a.765.765 0 0 0-.518.933.73.73 0 0 0 .897.538l1.887-.526a.73.73 0 0 1-.897-.538Z"
            fill="#EAB540"
          />
          <Path
            d="m16.311 22.065-6.603 1.84a.73.73 0 0 1-.897-.538.765.765 0 0 1 .518-.933l6.603-1.84a.73.73 0 0 1 .897.538.765.765 0 0 1-.518.933Z"
            fill="#FFECBC"
          />
          <Path
            d="M10.697 22.841a.765.765 0 0 1 .518-.933l-1.886.526a.765.765 0 0 0-.518.933.73.73 0 0 0 .897.538l1.886-.525a.73.73 0 0 1-.896-.539Z"
            fill="#EAB540"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h28v28H0z" />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" transform="translate(1 1)" d="M0 0h25v26H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DigitalGoldCategories
